import React from "react";

function Footer({ className }) {
  return (
    <footer className={className}>
      <p>© 2023 Upcycle</p>
      <sub>Contact us to fix your website</sub>
    </footer>
  );
}

export default Footer;
